/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PerTaskProperties } from './PerTaskProperties';

export type PerTask = {
    uuid: string;
    assignee?: number;
    customer_id: number;
    update_time?: string;
    site_name?: string;
    task_type: PerTask.task_type;
    status: PerTask.status;
    properties?: PerTaskProperties;
};

export namespace PerTask {

    export enum task_type {
        PER = 'per',
    }

    export enum status {
        NO_PER = 'no_per',
        PREPARE = 'prepare',
        LANDHOLDER_INPUT = 'landholder_input',
        PROCESS_CHANGES = 'process_changes',
        SUBMIT = 'submit',
        FINISH = 'finish',
    }


}

